export const ISSUE_CONSTANT = {
    LOAD_ISSUE_CONFIG: 'LOAD_ISSUE_CONFIG',
    SET_FROM_DRITY_FLAG: 'SET_FROM_DRITY_FLAG',
    CHANGE_IC_CARD_TYPE: 'CHANGE_IC_CARD_TYPE',
    CHANGE_IC_DESC: 'CHANGE_IC_DESC',
    CHANGE_IC_POS: 'CHANGE_IC_POS',
    CHANGE_TRIGGER_FONT_COLOR: 'CHANGE_TRIGGER_FONT_COLOR',
    CHANGE_TRIGGER_BG_COLOR: 'CHANGE_TRIGGER_BG_COLOR',
    CHANGE_TRIGGER_TEXT: 'CHANGE_TRIGGER_TEXT',
    UPDATE_ISSUE_COLLECTOR_CONFIG: 'UPDATE_ISSUE_COLLECTOR_CONFIG',
    EMPTY_ISSUE_COLLECTOR_CONFIG: 'EMPTY_ISSUE_COLLECTOR_CONFIG',
    CHANGE_SCREEN_TITLE: 'CHANGE_SCREEN_TITLE',
    CHANGE_INTRODUCTION_TEXT: 'CHANGE_INTRODUCTION_TEXT',
    CHANGE_ISSUE_TITLE: 'CHANGE_ISSUE_TITLE',
    CHANGE_DESCRIPTION_TITLE: 'CHANGE_DESCRIPTION_TITLE',
    IS_ATTACHMENT_AVAILABLE: 'IS_ATTACHMENT_AVAILABLE',
    RESET_ISSUE_CONFIG: 'RESET_ISSUE_CONFIG',
    POPULATE_CUSTOM_FIELDS: 'POPULATE_CUSTOM_FIELDS',
    SET_FIELD_SELECTION: 'SET_FIELD_SELECTION',
    REORDER_CUSTOM_FIELD: 'REORDER_CUSTOM_FIELD',
    UPDATE_DESCRIPTION_CONTROL_TYPE: 'UPDATE_DESCRIPTION_CONTROL_TYPE',
    CHANGE_ALLOWED_EMAIL_IDS: 'CHANGE_ALLOWED_EMAIL_IDS'
};